var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Edit role",
        description:
          "By changing the role, it will impact their access level within Blüm.",
        label: "Update",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-3 px-8" },
        [
          _c("BlInputText", { attrs: { input: _vm.nameInput } }),
          _vm._v(" "),
          _c("BlInputText", { attrs: { input: _vm.emailInput } }),
          _vm._v(" "),
          _c("BlSelectBox", {
            attrs: {
              label: "Role",
              asterisk: "",
              placeholder: "Select role",
              options: _vm.roleOptions
            },
            on: {
              change: function($event) {
                _vm.roleInput = $event
              }
            },
            model: {
              value: _vm.roleInput,
              callback: function($$v) {
                _vm.roleInput = $$v
              },
              expression: "roleInput"
            }
          }),
          _vm._v(" "),
          !_vm.isDisabledSubmit
            ? _c("BlTextBody2", {
                attrs: {
                  text:
                    "Are you sure you want to proceed with this role change?"
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6874e920", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6874e920","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/EditUserRoleModal.vue
// module id = null
// module chunks = 